import { PayoutRules_t } from "./payout-rules-model";

  export interface UserAttributes {
    uuid: string;
    username: string;
    first_name: string;
    last_name: string;
    email: string;
    password: string;
    role: string[];
    createdAt: Date;
    updatedAt: Date;
    address: string;
    phone_number: string;
    profilePicture: Uint8Array;
    account_status: string;
    user_api_key: string;
    user_oauth_secret: string;
    primary_use: string;
    logintype: boolean;
    service: string;
    full_address?: string;
    address_line_2?: string;
    stripe_customer_id?: string;
    payout_account_id?: string;
    apple_sub_identifier?: string;
    google_sub_identifier?: string;
    hostPayoutStatus?: string;
    zip_code?: string;
    city?: string;
    state?: string;
    street_number?: string;
    street_name?: string;
    country?: string;
    onboarding_tasks?: string[];
    partner_tasks?: string[];
    hostingEnabled: boolean;
    email_verified?: boolean;
    payoutRules?: PayoutRules_t;
    sub?: string;
    message?: string;
    // RFID tap-to-charge support (see RFID_TAP_TO_CHARGE_FRONTEND_CONTRACT.md)
    default_payment_method_id?: string | null;
    rfid_tap_push_enabled?: boolean;
  }
  

  export const createUser = (overrides?: Partial<UserAttributes>): UserAttributes => ({
    uuid: '',
    username: '',
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    role: [],
    createdAt: new Date(),
    updatedAt: new Date(),
    address: '',
    phone_number: '',
    profilePicture: new Uint8Array(), // Instantiate with an empty Uint8 array
    account_status: '',
    user_api_key: '',
    user_oauth_secret: '',
    logintype: false,
    primary_use: '',
    service: '',
    full_address: '',
    address_line_2: '',
    stripe_customer_id: '',
    payout_account_id: '',
    apple_sub_identifier: '',
    google_sub_identifier: '',
    hostPayoutStatus: '',
    zip_code: '',
    city: '',
    state: '',
    street_number: '',
    street_name: '',
    country: '',
    onboarding_tasks: [],
    partner_tasks: [],
    hostingEnabled: false,
    email_verified: false,
    payoutRules: undefined,
    sub: '',
    message: '',
    default_payment_method_id: null,
    rfid_tap_push_enabled: true,
    ...overrides,
  });

  
export interface LoginRegister {
  uuid: string;
  username: string;
  password: string;
  first_name: string;
  last_name: string;
  email: string;
  role: string[];
  IpAddress: string;
  address?: string;
  phone_number?: string;
  profilePicture?: string;
  account_status?: string;
  user_api_key?: string;
  user_oauth_secret?: string;
  logintype: boolean;
}

  export const createLoginRegister = (overrides?: Partial<LoginRegister>):LoginRegister => ({
    uuid: '',
    username: '',
    password: '',
    first_name: '',
    last_name: '',
    email: '',
    IpAddress: '',
    role: [],
    address: '',
    phone_number: '',
    profilePicture: '',
    account_status: '',
    user_api_key: '',
    logintype: false,
    user_oauth_secret: '',
    ...overrides
  });